<template>
  <div class="list-box dialog-dom" id="huiyi_detail">
    <div class="flex items-center p-4">
      <div class="flex-1">
        <div class="flex items-center gap-x-3">
          <c_status
            arrName="Meeting_Status"
            showBg
            :value="state.model?.status"
            :key="state.model?.status"
          />
          <strong>{{ state.model?.name }}</strong>
          <text>{{ "[" + state.model?.number + "]" }}</text>
          <c_cell title="项目经理" class="ml-3">
            <template #default>
              <text>{{ state.model?.belonger_name }}</text>
              <text class="ml-1 text-xs text-gray-400">
                {{ state.model?.belonger_department_name }}
              </text>
            </template>
          </c_cell>
          <c_cell title="主办单位" :value="state.model?.sponsor"></c_cell>
          <c_cell title="承办单位" :value="state.model?.organizer"></c_cell>
          <el-icon color="var(--el-color-danger)">
            <LocationFilled />
          </el-icon>
          <text class="text-gray-400 text-sm" style="margin-left: -10px">
            {{
              state.model?.province +
              state.model?.city +
              state.model?.district +
              state.model?.address
            }}
          </text>
          <el-icon
            class="!text-green-600 cursor-pointer !text-lg hover:!text-xl"
            @click="state.showEdit = true"
            ><Edit
          /></el-icon>
          <div class="flex-1 flex justify-end">
            <el-button
              type="success"
              :icon="Document"
              link
              @click="onChouBei"
              v-if="
                state.model?.id &&
                btn_status.kaishichoubei?.includes(state.model?.status)
              "
              >开始筹备
            </el-button>
            <el-button
              type="danger"
              :icon="Document"
              link
              @click="onJinXing"
              v-if="
                state.model?.id &&
                btn_status.jinxing?.includes(state.model?.status)
              "
              >标记进行-测试
            </el-button>
            <el-button
              type="danger"
              :icon="Document"
              link
              @click="onJieShu"
              v-if="
                state.model?.id &&
                btn_status.jieshu?.includes(state.model?.status)
              "
              >标记结束-测试
            </el-button>
            <el-button
              :icon="Close"
              link
              @click="onQuXiao"
              color="#a2a2a2"
              v-if="
                state.model?.id &&
                btn_status.quxiao?.includes(state.model?.status)
              "
              >取消会议
            </el-button>
            <el-button
              type="success"
              :icon="Select"
              link
              @click="onWanCheng"
              v-if="
                state.model?.id &&
                btn_status.wancheng?.includes(state.model?.status)
              "
              >完成
            </el-button>
            <el-button
              type="info"
              :icon="Select"
              link
              @click="
                delete state.hesuan_search;
                state.showHeSuan = true;
              "
              color="#080"
              v-if="
                state.model?.id &&
                btn_status.tijiaohesuan?.includes(state.model?.status) &&
                state.model?.belonger_id == $store.state?.loginUser?.id
              "
              >提交核算
            </el-button>
            <!-- <el-button
              type="info"
              :icon="Select"
              link
              @click="
                delete state.hesuan_search;
                state.showHeSuan = true;
              "
              color="#080"
              >提交核算
            </el-button> -->
            <el-button
              type="info"
              :icon="Search"
              link
              @click="
                state.hesuan_search = true;
                state.showHeSuan = true;
              "
              color="#080"
              v-if="
                state.model?.id &&
                btn_status.chakanhesuan?.includes(state.model?.status)
              "
            >
              查看核算单
            </el-button>
          </div>
        </div>
        <div class="flex items-center mt-2 gap-x-5 flex-wrap gap-y-2">
          <c_cell
            title="会议日期"
            :value="state.model?.start_date + ' ~ ' + state.model?.end_date"
          ></c_cell>
          <c_cell title="会议天数" :value="state.model?.days + '天'"></c_cell>
          <c_cell
            title="报名开始时间"
            :value="
              $dayjs(state.model?.signup_start_time).format('YYYY-MM-DD HH:mm')
            "
          ></c_cell>
          <c_cell
            title="报名结束时间"
            :value="
              $dayjs(state.model?.signup_end_time).format('YYYY-MM-DD HH:mm')
            "
          ></c_cell>
          <c_cell title="住宿" :value="state.model?.accommodation"></c_cell>
          <c_cell title="用餐" :value="state.model?.catering"></c_cell>
          <c_cell
            title="单据抬头"
            class="flex-1"
            :value="state.model?.bill_title || '-'"
          ></c_cell>
          <text
            class="text-xs text-orange-500"
            v-if="
              btn_status.tijiaohesuan?.includes(state.model?.status) ||
              btn_status.chakanhesuan?.includes(state.model?.status)
            "
            >请注意：当会议提交核算后（会议状态为核算中或已核算）则会议所有操作及数据即被锁定，不允许操作！</text
          >
        </div>
      </div>

      <!-- <el-button
        type="danger"
        :icon="Close"
        link
        @click="onQuXiaoHeSuan"
        v-if="
          state.model?.id &&
          btn_status.quxiaohesuan?.includes(state.model?.status)
        "
        >取消核算
      </el-button>
      <el-button
        :icon="Printer"
        link
        Plain
        @click="onHeSuan"
        v-if="
          state.model?.id &&
          btn_status.dayinhesuan?.includes(state.model?.status)
        "
        >打印核算单
      </el-button> -->
    </div>
    <div
      class="flex-1 overflow-hidden gap-x-3 border-t grid"
      style="grid-template-columns: 160px 1fr"
    >
      <div class="overflow-y-auto my-2 px-2 flex flex-col gap-y-1">
        <ul
          v-for="item in menus"
          :key="item"
          class="flex items-center gap-x-3 p-3 text-sm rounded cursor-pointer hover:bg-gray-100 text-gray-400"
          :class="
            state.menu == item.name ? 'bg-blue-50 font-bold text-gray-900' : ''
          "
          @click="state.menu = item.name"
        >
          <el-icon>
            <component :is="item.icon" />
          </el-icon>
          <text>{{ item.name }}</text>
        </ul>
      </div>
      <div class="h-full pt-2.5 rounded-lg overflow-hidden">
        <c_more
          :meeting_id="state.model?.id"
          v-if="state.menu == '会议信息' && state.model?.id"
          @toRiCheng="state.menu = '日程管理'"
        />
        <c_wangzhan
          :meeting_id="state.model?.id"
          v-if="state.menu == '网站管理' && state.model?.id"
          @refresh="onLoad"
        />
        <c_fenhui
          :meeting_id="state.model?.id"
          v-if="state.menu == '分会管理' && state.model?.id"
        />
        <c_richeng
          :meeting_id="state.model?.id"
          v-if="state.menu == '日程管理' && state.model?.id"
        />
        <c_wuliao
          :meeting_id="state.model?.id"
          v-if="state.menu == '物料管理' && state.model?.id"
        />
        <c_rizhi
          :meeting_id="state.model?.id"
          v-if="state.menu == '会议日志' && state.model?.id"
        />
        <c_shoukuan
          :meeting_id="state.model?.id"
          v-if="state.menu == '收款计划' && state.model?.id"
        />
        <c_baozhang
          :meeting_id="state.model?.id"
          :tax_fee_rate="state.model.tax_fee_rate"
          @refresh="onLoad()"
          v-if="state.menu == '报账管理' && state.model?.id"
        />
        <c_caigou
          :meeting_id="state.model?.id"
          v-if="state.menu == '采购管理' && state.model?.id"
        />
        <c_fapiao
          :meeting_id="state.model?.id"
          :meeting_bill_title="state.model?.bill_title"
          v-if="state.menu == '发票管理' && state.model?.id"
        />
        <c_renyuan
          :meeting_id="state.model?.id"
          v-if="state.menu == '参会人员' && state.model?.id"
        />
        <c_zhusu
          :meeting_id="state.model?.id"
          v-if="state.menu == '住宿安排' && state.model?.id"
        />
        <c_cheliang
          :meeting_id="state.model?.id"
          :meeting_start_date="state.model?.start_date"
          :meeting_end_date="state.model?.end_date"
          v-if="state.menu == '车辆管理' && state.model?.id"
        />
        <c_shezhi
          :meeting_id="state.model?.id"
          v-if="state.menu == '会议设置' && state.model?.id"
        />
        <c_jilu
          :meeting_id="state.model?.id"
          v-if="state.menu == '操作记录' && state.model?.id"
        />
      </div>
    </div>
  </div>
  <el-dialog
    v-model="state.showEdit"
    title="编辑会议"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showEdit = false;
      }
    "
  >
    <c_info
      :id="props.data?.id"
      @close="
        state.showEdit = false;
        onLoad();
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showHeSuan"
    title="提交核算"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showHeSuan = false;
      }
    "
    width="70%"
  >
    <c_hesuan
      :search="state.hesuan_search"
      :id="props.data?.id"
      @close="
        state.showHeSuan = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";

import {
  meeting_detail,
  meeting_cancel,
  meeting_startPrepare,
  meeting_complete,
  meeting_starting,
  meeting_end,
} from "@/http/meeting";
import { ElMessageBox } from "element-plus";
import { post_response } from "@/utils/funcs";

import c_info from "./Info.vue";
import c_hesuan from "./HeSuan.vue";

import c_more from "./Detail/More.vue";
import c_wangzhan from "./Detail/WangZhan/Index.vue";
import c_fenhui from "./Detail/FenHui/List.vue";
import c_richeng from "./Detail/RiCheng/List.vue";
import c_wuliao from "./Detail/WuLiao/List.vue";
import c_rizhi from "./Detail/RiZhi/List.vue";
import c_shoukuan from "./Detail/ShouKuan/List.vue";
import c_baozhang from "./Detail/BaoZhang/List.vue";
import c_caigou from "./Detail/CaiGou/List.vue";
import c_fapiao from "./Detail/FaPiao/List.vue";
import c_renyuan from "./Detail/RenYuan/List.vue";
import c_zhusu from "./Detail/ZhuSu/List.vue";
import c_cheliang from "./Detail/CheLiang/List.vue";
import c_shezhi from "./Detail/SheZhi/Index.vue";
import c_jilu from "./Detail/JiLu/List.vue";

export default {
  props: {
    data: Object,
  },
  components: {
    c_info,
    c_hesuan,
    c_more,
    c_wangzhan,
    c_fenhui,
    c_richeng,
    c_wuliao,
    c_rizhi,
    c_shoukuan,
    c_baozhang,
    c_caigou,
    c_fapiao,
    c_renyuan,
    c_zhusu,
    c_cheliang,
    c_shezhi,
    c_jilu,
  },
  setup(props) {
    const menus = [
      { name: "会议信息", icon: "Document" },
      { name: "网站管理", icon: "Menu" },
      { name: "分会管理", icon: "OfficeBuilding" },
      { name: "日程管理", icon: "Calendar" },
      // { name: "物料管理", icon: "Goods" },
      { name: "会议日志", icon: "Notebook" },
      { name: "收款计划", icon: "Clock" },
      { name: "报账管理", icon: "Tickets" },
      { name: "采购管理", icon: "ShoppingCart" },
      { name: "发票管理", icon: "Tickets" },
      { name: "参会人员", icon: "User" },
      { name: "住宿安排", icon: "House" },
      { name: "车辆管理", icon: "Van" },
      { name: "会议设置", icon: "Setting" },
      // { name: "操作记录", icon: "Operation" },
    ];
    //操作按钮显示的状态
    const btn_status = {
      kaishichoubei: [0], //开始筹备    策划中
      quxiao: [0], //取消会议  策划中
      wancheng: [3], //会议完成  已结束
      tijiaohesuan: [4, 6], //提交核算  已完成、不通过
      chakanhesuan: [5, 6, 7], //显示核算单，核算单可以操作：提交核算、取消核算、打印核算单      状态：5:核算中,6:不通过,7:已核算
      quxiaohesuan: [7], //取消核算  已核算
      jinxing: [1], //标记进行  筹备中
      jieshu: [2], //标记结束  进行中
      dayinhesuan: [6, 7], //提交核算  已完成、不通过
    };
    const state = reactive({
      menu: "会议信息",
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      meeting_detail(props.data.id).then((res) => {
        if (res.status == 200) {
          state.model = res.data?.data || {};
        }
      });
    };

    //开始筹备
    const onChouBei = () => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-success);">开始筹备</strong>该会议吗`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_startPrepare(props.data?.id).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              onLoad();
            }, 500);
          });
        });
      });
    };

    //取消会议
    const onQuXiao = () => {
      ElMessageBox.confirm(
        `您确定<strong style="color: #a2a2a2">取消</strong>该会议吗`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_cancel(props.data?.id).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              onLoad();
            }, 500);
          });
        });
      });
    };

    //完成会议
    const onWanCheng = () => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-success);">完成会议</strong>吗`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_complete(props.data?.id).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              onLoad();
            }, 500);
          });
        });
      });
    };

    //标记进行
    const onJinXing = () => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-danger);">标记进行</strong>吗`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_starting(props.data?.id).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              onLoad();
            }, 500);
          });
        });
      });
    };

    //标记结束
    const onJieShu = () => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-danger);">标记结束</strong>吗`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_end(props.data?.id).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              onLoad();
            }, 500);
          });
        });
      });
    };

    return {
      state,
      props,
      menus,
      onLoad,
      btn_status,
      onChouBei,
      onQuXiao,
      onWanCheng,
      onJinXing,
      onJieShu,
    };
  },
};
</script>

<style lang="less" scoped></style>
